'use client'
import Image from 'next/image'
import { Button } from './ui/button'
import { usePathname, useRouter } from 'next/navigation'
import { v4 as uuidV4 } from 'uuid'
import React from 'react'
type Props = {
  code: number
  reset?: () => void
}

export const ErrorPage = ({ code, reset }: Props) => {
  const router = useRouter()
  const path = usePathname()

  React.useEffect(() => {
    // eslint-disable-next-line no-console
    process.env.NEXT_PUBLIC_ENV !== 'prod' && console.log({ errorCode: code })
  }, [code])

  const { errorNumber, title, descriptions, button, onClick } =
    React.useCallback(() => {
      if (code === 404) {
        return {
          errorNumber: code.toString(),
          title: '페이지를 찾을 수 없어요',
          // 줄바꿈 및 description footer를 위한 배열 처리
          descriptions: [
            '페이지 주소가 변경/삭제 되어',
            '더이상 찾을 수 없어요.',
            '입력하신 주소가 정확한지 다시 한 번 확인해주세요.',
          ],
          button: '홈으로 돌아가기',
          onClick: () => {
            router.replace('/')
          },
        }
      }
      if (code === 400) {
        return {
          errorNumber: code.toString(),
          title: '잘못된 접근입니다.',
          descriptions: ['요청하신 페이지에 접근할 수 없습니다.'],
          button: '홈으로 돌아가기',
          onClick: () => {
            router.replace('/')
          },
        }
      }
      return {
        errorNumber: null,
        title: '시스템 오류가 발생했습니다.',
        descriptions: [
          '문제 해결을 위해 노력하고 있습니다. 잠시 후 다시 확인해주세요.',
        ],
        button: '홈으로 돌아가기',
        onClick: () => {
          if (path === '/' && reset) {
            reset()
            return
          }
          router.replace('/')
        },
      }
    }, [code, path, router, reset])()

  return (
    <main className="relative flex h-screen flex-col items-center justify-center">
      <Image
        src="/images/404-page-background.png"
        width={362}
        height={520}
        alt=""
        className="absolute"
        priority
      />
      <div className="relative -top-5 flex">
        {errorNumber ? (
          <>
            <p className="text-6xl font-extrabold text-primary">
              <span className="absolute right-[3.25rem]">{errorNumber[0]}</span>
              <span className="absolute left-[3.25rem]">{errorNumber[2]}</span>
            </p>
            <Image
              src="/icons/solar-bell-bold-duotone.svg"
              width={60}
              height={60}
              alt=""
              className="scale-105"
              priority
            />
          </>
        ) : (
          <Image
            src="/icons/error-500.svg"
            width={64}
            height={64}
            alt=""
            priority
          />
        )}
      </div>
      <h2 className="relative mb-[8px] text-body-01-semi">{title}</h2>
      {descriptions.map((description, i) => (
        <p
          key={uuidV4()}
          className={`relative ${descriptions.length - 2 <= i && 'pb-[30px]'} text-caption-01-regular text-gray-5`}
        >
          {description}
        </p>
      ))}
      <Button className="relative w-[255px]" onClick={onClick}>
        {button}
      </Button>
    </main>
  )
}
